import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import React from "react";

function MyCountdown() {
    const Completionist = () => <span>You are good to go!</span>;

    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return (
                <div className="flex countdown-block gap-4 mb-5 md:mb-0">
                    <div className="flex items-start gap-2">
                        <div className="text-center">
                            <div className="countdown-date w-[60px] px-3 py-1 font-bold text-3xl uppercase mb-1 border-0 bg-white">
                                {days}
                            </div>
                            <div className='text-xs'>Днів</div>
                        </div>

                        <div className="text-3xl font-bold">:</div>

                        <div className="text-center">
                            <div className="countdown-date w-[60px] px-3 py-1 font-bold text-3xl uppercase mb-1 border-0 bg-white">
                                {hours}
                            </div>
                            <div className='text-xs'>Годин</div>
                        </div>

                        <div className="text-3xl font-bold">:</div>

                        <div className="text-center">
                            <div className="countdown-date w-[60px] px-3 py-1 font-bold text-3xl uppercase mb-1 border-0 bg-white">
                                {minutes}
                            </div>
                            <div className='text-xs'>Хвилин</div>
                        </div>

                        <div className="text-3xl font-bold">:</div>

                        <div className="text-center">
                            <div className="countdown-date w-[60px] px-3 py-1 font-bold text-3xl uppercase mb-1 border-0 bg-white">
                                {seconds}
                            </div>
                            <div className='text-xs'>Секунд</div>
                        </div>
                    </div>
                </div>
            );
        }
    };

    return (
        <div className="flex flex-col gap-[14px] lg:items-center lg:flex-row md:mb-5 md:gap-6 relative z-10">
            <div className="uppercase text-[#010b13] font-medium lg:max-w-[120px]">
                Пропозиція діє ще:
            </div>
            <Countdown
                date={Date.now() + (new Date('2026-07-08T00:00:00') - Date.now())}
                renderer={renderer}
            />
        </div>
    )
}

export default MyCountdown